import React from 'react';
import { cn } from './Card';
interface ProgressRingProps {
  value: number;
  max?: number;
  size?: number;
  strokeWidth?: number;
  colorClass?: string;
  className?: string;
  showValue?: boolean;
}
export function ProgressRing({
  value,
  max = 100,
  size = 64,
  strokeWidth = 6,
  colorClass = 'text-slate-900',
  className,
  showValue = true
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const safeValue = Math.min(Math.max(value, 0), max);
  const percent = safeValue / max;
  const offset = circumference - percent * circumference;
  return <div className={cn('relative inline-flex items-center justify-center', className)} style={{
    width: size,
    height: size
  }} data-id="element-303">
      <svg className="transform -rotate-90" width={size} height={size} data-id="element-304">
        <circle className="text-slate-100" strokeWidth={strokeWidth} stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-305" />
        <circle className={cn('transition-all duration-1000 ease-out', colorClass)} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-306" />
      </svg>
      {showValue && <div className="absolute inset-0 flex items-center justify-center" data-id="element-307">
          <span className="text-sm font-semibold text-slate-700" data-id="element-308">
            {Math.round(safeValue / max * 100)}%
          </span>
        </div>}
    </div>;
}